import { gql } from '@apollo/client';

export const CONSUMER_WALLET_QUERY = gql`
  query ConsumerWallet {
    consumerWallet {
      walletCardLink
    }
  }
`;